import * as yup from 'yup';
import { LINK_GENERATION_VALIDATION } from '../constants/generateLink';
import { isFutureDate, validateYear } from '../utils/utils';

export const REVIEW_DATE_VALIDATION = {
  REVIEW_DATE_REQUIRED: 'Enter the review date',
  REVIEW_DATE_REQ: ['Enter the review month', 'Enter the review day', 'Enter the review year', 'Enter the review date'],
  REVIEW_DATE_REQUIRED_ALERT_FIELD: 'Enter the review date',
  REVIEW_DATE_INVALID: 'Enter the review date as: \nMM/DD/YYYY',
  REVIEW_DATE_FUTURE_ALERT_FIELD: 'Enter a valid review date',
  REVIEW_DATE_FUTURE: 'Future dates are not valid',
  REVIEW_DATE_OLD: 'Enter a review date in the past 5 years',
};

export const MAX_NICKNAME_LENGTH = 40;
export const MAX_COMMENT_LENGTH = 6000;

export const generateXIDSchema = () => {
  return yup
      .object({
        realmId: yup
          .string()
          .required(LINK_GENERATION_VALIDATION.REALM_ID_REQUIRED)
          .oneOf(['H100', 'CVS'], LINK_GENERATION_VALIDATION.REALM_ID_INVALID),
        appType: yup
          .string()
          .required(LINK_GENERATION_VALIDATION.APP_STORE_REQUIRED)
          .oneOf(['iOS','Google'],LINK_GENERATION_VALIDATION.APP_STORE_INVALID),
        nickName: yup
          .string()
          .required(LINK_GENERATION_VALIDATION.APP_STORE_USERNAME_REQUIRED)
          .max(MAX_NICKNAME_LENGTH, LINK_GENERATION_VALIDATION.APP_STORE_USERNAME_INVALID),
        reviewComment: yup
          .string()
          .required(LINK_GENERATION_VALIDATION.ORIGINAL_REVIEW_REQUIRED)
          .max(MAX_COMMENT_LENGTH, LINK_GENERATION_VALIDATION.ORIGINAL_REVIEW_INVALID),
        reviewDate: yup
          .string()
          .required(REVIEW_DATE_VALIDATION.REVIEW_DATE_REQUIRED)
          .test({
          name: 'validateDate',
          test(value, ctx) {
            const { reviewDate } = ctx?.parent || {};
            const futureDate = isFutureDate(reviewDate);
            if (futureDate) {
              return ctx.createError({ message: REVIEW_DATE_VALIDATION.REVIEW_DATE_FUTURE });
            }
            const validYear = validateYear(reviewDate.substr(0,4));
            if (!validYear) {
              return ctx.createError({ message: REVIEW_DATE_VALIDATION.REVIEW_DATE_OLD });
            }
            return true;
          }
        }),
      })
      .required();
};
